import { IonContent, IonItem, IonLabel, IonModal } from "@ionic/react";
import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";

const objectSets = [
    ["🍎", "🍌", "🍇"], ["🚗", "🚌", "🚲"], ["🏀", "⚽", "🏐"],
    ["🐶", "🐱", "🐭"], ["✈️", "🚁", "🚢"], ["🌞", "🌍", "🌊"],
    ["🎈", "🎁", "🎂"], ["🌲", "🌳", "🌿"], ["🏠", "🏢", "🏬"],
    ["📕", "📘", "📗"], ["🐘", "🦓", "🦒"], ["🍔", "🍟", "🥤"],
    ["🚀", "🛰", "🌍"], ["🎤", "🎸", "🥁"], ["🏕", "🔥", "🛶"],
    ["🚴", "🏍", "🚂"], ["🎭", "🎨", "🎬"], ["🦄", "🐉", "🐲"],
    ["🛸", "🛶", "🚤"], ["🦅", "🦆", "🐧"], ["🍓", "🍒", "🍉"],
    ["🐳", "🐬", "🐟"], ["🎯", "🎳", "🎮"], ["⚔️", "🛡", "🏹"],
    ["🔬", "📡", "💡"], ["🌵", "🍀", "🌻"], ["🛵", "🚜", "🚛"],
    ["🦖", "🦕", "🐢"], ["📱", "💻", "🖥"], ["🎺", "🎻", "🥁"],
    ["🧩", "♟", "🎲"], ["📖", "📚", "📰"], ["🌈", "☁️", "🌙"],
    ["🎠", "🎢", "🎡"], ["🍕", "🌮", "🍣"], ["🍩", "🧁", "🍪"],
    ["🥦", "🥕", "🌽"], ["🦜", "🦢", "🦉"], ["🏖", "🏔", "🏜"],
    ["🛳", "🚁", "🚀"], ["🗻", "🏕", "🏝"], ["🛶", "🚤", "⛵"],
    ["🎭", "🎷", "🎺"], ["⚽", "🏈", "🏀"], ["🎹", "🎻", "🎷"],
    ["🦋", "🐞", "🐛"], ["🔑", "🗝", "💰"], ["⚓", "⛵", "🚢"],
    ["🚦", "🚥", "🛑"], ["🏯", "🏰", "🕌"], ["🦊", "🐻", "🐺"],
    ["💎", "📿", "💰"], ["🦎", "🐍", "🐸"], ["🏎", "🚜", "🚛"],
    ["🌼", "🌷", "💐"], ["🎃", "🧛", "👻"], ["🛷", "⛸", "🎿"],
    ["🦆", "🦉", "🦜"], ["🍯", "🍵", "🥛"], ["🧀", "🥖", "🥚"],
    ["🦔", "🐇", "🦨"], ["🛶", "🚤", "🚢"], ["🦜", "🦢", "🦆"],
    ["🚁", "🛫", "🚀"], ["🍎", "🍐", "🍊"], ["🦉", "🐦", "🦜"],
    ["🎂", "🍪", "🧁"], ["🦖", "🦕", "🐢"], ["🧸", "🪀", "🎲"],
    ["📻", "📺", "🎧"], ["🎃", "🎄", "🎁"], ["🥄", "🍴", "🔪"],
    ["💎", "🔮", "⚱"], ["🎩", "👑", "🎓"], ["🌜", "🌞", "🌛"],
    ["🍓", "🍒", "🍉"], ["🚕", "🚙", "🚐"], ["🦁", "🐯", "🐻"],
    ["🎷", "🎸", "🎺"], ["🏅", "🥇", "🥈"], ["📏", "📐", "📎"],
    ["🏡", "🏢", "🏰"], ["🎠", "🎪", "🎢"], ["📷", "🎥", "📽"],
    ["🌵", "🌴", "🎋"], ["🥇", "🥈", "🥉"], ["🍵", "☕", "🥤"],
    ["🛶", "🚤", "⛴"], ["🦌", "🐗", "🐘"], ["🌻", "🌺", "🌼"],
    ["📀", "💽", "💾"], ["🔮", "🪄", "🎩"], ["🥋", "🎽", "🥊"],
    ["🚜", "🚛", "🚚"], ["🎠", "🎢", "🎡"], ["📍", "🧭", "🗺"],
    ["🌞", "🌚", "🌕"], ["🍎", "🍑", "🍏"], ["🚴", "🛹", "🛼"],
    ["🕹", "🎮", "📟"], ["🚁", "🛩", "✈️"], ["🦕", "🦖", "🦣"],
    ["🥑", "🍠", "🥔"], ["📻", "🎧", "📱"], ["🎭", "🎟", "🎬"],
    ["🏆", "🏅", "🥇"], ["📦", "🎁", "🛍"], ["🎸", "🎷", "🎺"],
    ["🎠", "🎡", "🎢"], ["📖", "📚", "📜"], ["🛷", "⛸", "🎿"],
    ["🌄", "🏞", "🗻"], ["📱", "💻", "🖥"], ["🍕", "🍔", "🌭"],
    ["🐠", "🐟", "🐡"], ["📅", "🗓", "📆"], ["📞", "📟", "📠"],
    ["🍚", "🍙", "🍘"], ["📊", "📈", "📉"], ["🎤", "🎧", "📻"],
    ["🚑", "🚒", "🚓"], ["🔬", "🔭", "🧪"], ["🔔", "🎵", "🎶"],
    ["🧩", "🃏", "🎴"], ["🌜", "🌞", "🌛"], ["🍀", "🌹", "🌷"],
    ["🏞", "🏕", "🏔"], ["🏄", "🏊", "🚣"], ["🛒", "🛍", "🎁"],
    ["📯", "🎺", "🎷"], ["📹", "🎥", "📽"], ["🏗", "🏠", "🏢"],
    ["🔑", "🗝", "💰"], ["🦈", "🐋", "🐊"], ["🍵", "☕", "🥤"],
    ["🌵", "🌴", "🎋"], ["🏔", "🗻", "🏞"], ["📞", "📟", "📠"],
    ["🍀", "🌿", "☘"], ["🎖", "🏅", "🥇"], ["🏝", "🏜", "🏞"],
    ["🎠", "🎡", "🎢"], ["🍉", "🍓", "🍇"], ["🎙", "🎤", "🎧"]
];


const BeforeAfter: React.FC = () => {
    const [question, setQuestion] = useState("");
    const [correctAnswer, setCorrectAnswer] = useState("");
    const [message, setMessage] = useState("");
    const [currentObjects, setCurrentObjects] = useState<string[]>([]);
    const [showImage, setShowImage] = useState(false);
    const modal = useRef<HTMLIonModalElement>(null);

    useEffect(() => {
        generateQuestion();
        document.title = "Before, After and Between – LKG Pre-Math Concepts | Mama’s Guidance"; // Set page title
    }, []);

    const generateQuestion = () => {
        const randomSet = objectSets[Math.floor(Math.random() * objectSets.length)];
        setCurrentObjects(randomSet);

        const randomType = Math.random();
        let newQuestion = "";
        let correct = "";

        if (randomType < 0.33) {
            newQuestion = `Choose the object before ${randomSet[1]}.`;
            correct = randomSet[0];
        } else if (randomType < 0.66) {
            newQuestion = `Choose the object after ${randomSet[1]}.`;
            correct = randomSet[2];
        } else {
            newQuestion = `Choose the object in the between.`;
            correct = randomSet[1];
        }

        setQuestion(newQuestion);
        setCorrectAnswer(correct);
    };

    const checkAnswer = (selected: string) => {
        if (selected === correctAnswer) {
            setShowImage(true);
            setTimeout(() => {
                generateQuestion()
                setShowImage(false);
                setMessage("")
            }, 5000)
        } else {
            setShowImage(false);
            setMessage("❌ Oops! Try again.");
        }
    };

    return (
        <>
            <Helmet>
                <meta name="description" content='Introduce LKG children to the concepts of before and after with fun, interactive activities on Mama’s Guidance—designed to develop early sequencing and logical thinking skills through playful and visual learning.' />
            </Helmet>
            {
                showImage === false ?
                    <>
                        <div className="contentPart additionWord pickColor matchImage match-container" style={{ textAlign: "center", padding: "20px" }}>
                            <div className="showInfo" style={{ width: '80%' }} onClick={() => modal.current?.present()}><i className="fas fa-info-circle"></i></div>
                            <IonModal
                                ref={modal}
                                trigger="open-modal"
                                initialBreakpoint={1}
                                breakpoints={[0, 0.5, 0.75, 1]}
                                handleBehavior="cycle"
                                backdropDismiss={false}  // ✅ Prevents click-to-close
                                className="full-page-modal"
                            >
                                <IonContent className="ion-padding">
                                    <div style={{ textAlign: 'right', fontSize: '25px' }} onClick={() => modal.current?.dismiss()}><i className="fas fa-3a fa-times"></i></div>
                                    <h1>Before, After and Between</h1>

                                    <p>
                                        Before young learners begin working with numbers, they need to understand how objects are placed and ordered in space. This worksheet introduces the important pre-math spatial concepts of <strong>before</strong>, <strong>after</strong>, and <strong>between</strong> using colorful and engaging images — perfect for LKG-level children.
                                    </p>

                                    <h2>📌 What Are Spatial Concepts?</h2>
                                    <p>
                                        Spatial concepts teach children how to relate objects based on position and direction. They form the basis of math, reading, and daily life understanding.
                                        <strong>Before, after, and between</strong> are essential pre-math concepts in this category.
                                    </p>

                                    <h2>🔍 Understanding Before, After, and Between</h2>
                                    <ul>
                                        <li><strong>Before:</strong> Something placed in front of another object</li>
                                        <li><strong>After:</strong> Something that comes behind another object</li>
                                        <li><strong>Between:</strong> An object placed in the middle of two others</li>
                                    </ul>
                                    <p>Example: A teddy is <b><em>between</em></b> a ball and a book. A spoon is <b><em>before</em></b> the plate. The cup is <b><em>after</em></b> the plate.</p>

                                    <h2>🎯 What Will Your Child Learn?</h2>
                                    <ul>
                                        <li>Understanding position and order in real-world arrangements</li>
                                        <li>Building observation and language skills</li>
                                        <li>Enhancing attention to <strong>detail and directional thinking</strong></li>
                                        <li>Preparing for future lessons in <strong>number sequencing and directions</strong></li>
                                    </ul>

                                    <h2>🧩 What’s Inside the Worksheet?</h2>
                                    <ul>
                                        <li>Colorful images with common objects in various arrangements</li>
                                        <li>Questions like “What is <strong>before</strong> the ball?” or “What is <strong>between</strong> the chair and the table?”</li>
                                        <li>Circle the correct object tasks</li>
                                        <li>Drag and match style visual activities (if interactive)</li>
                                    </ul>

                                    <h2>👩‍🏫 How to Teach This Concept</h2>
                                    <ul>
                                        <li>Line up toys and ask your child to identify what’s before or after each item</li>
                                        <li>Use daily items like fruits, utensils, or crayons for fun positioning games</li>
                                        <li>Practice with storybooks or pictures: <strong>“What is between the cat and the dog?”</strong></li>
                                        <li>Reinforce with real scenarios like <strong>“Who is standing <em>after</em> you in line?”</strong></li>
                                    </ul>


                                    <h2>🔗 Related Topics</h2>
                                    <div>
                                        <IonItem routerLink="/lkg/mathematics/pre-math-concepts/long-short"
                                            routerDirection="none"
                                            lines="none"
                                            detail={true}>
                                            <IonLabel>Long - Short</IonLabel>
                                        </IonItem>
                                        <IonItem routerLink="/lkg/mathematics/pre-math-concepts/big-small"
                                            routerDirection="none"
                                            lines="none"
                                            detail={true}>
                                            <IonLabel>Big - Small</IonLabel>
                                        </IonItem>
                                        <IonItem routerLink="/lkg/mathematics/pre-math-concepts/full-empty"
                                            routerDirection="none"
                                            lines="none"
                                            detail={true}>
                                            <IonLabel>Full - Empty</IonLabel>
                                        </IonItem>
                                    </div>

                                    <h2>🧠 Why This Concept Is Important</h2>
                                    <p>
                                        By learning about <strong>heavy and light</strong>, children begin to understand <strong>mass, balance, and physical comparison</strong>. It prepares them for real-world decision-making and future science or math learning.
                                    </p>

                                    <div className="btn hero-btn" onClick={() => modal.current?.dismiss()}>Close</div>
                                </IonContent>
                            </IonModal>
                            <article className="visually-hidden">
                                <h1>Before, After and Between</h1>

                                <p>
                                    Before young learners begin working with numbers, they need to understand how objects are placed and ordered in space. This worksheet introduces the important pre-math spatial concepts of <strong>before</strong>, <strong>after</strong>, and <strong>between</strong> using colorful and engaging images — perfect for LKG-level children.
                                </p>

                                <h2>📌 What Are Spatial Concepts?</h2>
                                <p>
                                    Spatial concepts teach children how to relate objects based on position and direction. They form the basis of math, reading, and daily life understanding.
                                    <strong>Before, after, and between</strong> are essential pre-math concepts in this category.
                                </p>

                                <h2>🔍 Understanding Before, After, and Between</h2>
                                <ul>
                                    <li><strong>Before:</strong> Something placed in front of another object</li>
                                    <li><strong>After:</strong> Something that comes behind another object</li>
                                    <li><strong>Between:</strong> An object placed in the middle of two others</li>
                                </ul>
                                <p>Example: A teddy is <b><em>between</em></b> a ball and a book. A spoon is <b><em>before</em></b> the plate. The cup is <b><em>after</em></b> the plate.</p>

                                <h2>🎯 What Will Your Child Learn?</h2>
                                <ul>
                                    <li>Understanding position and order in real-world arrangements</li>
                                    <li>Building observation and language skills</li>
                                    <li>Enhancing attention to <strong>detail and directional thinking</strong></li>
                                    <li>Preparing for future lessons in <strong>number sequencing and directions</strong></li>
                                </ul>

                                <h2>🧩 What’s Inside the Worksheet?</h2>
                                <ul>
                                    <li>Colorful images with common objects in various arrangements</li>
                                    <li>Questions like “What is <strong>before</strong> the ball?” or “What is <strong>between</strong> the chair and the table?”</li>
                                    <li>Circle the correct object tasks</li>
                                    <li>Drag and match style visual activities (if interactive)</li>
                                </ul>

                                <h2>👩‍🏫 How to Teach This Concept</h2>
                                <ul>
                                    <li>Line up toys and ask your child to identify what’s before or after each item</li>
                                    <li>Use daily items like fruits, utensils, or crayons for fun positioning games</li>
                                    <li>Practice with storybooks or pictures: <strong>“What is between the cat and the dog?”</strong></li>
                                    <li>Reinforce with real scenarios like <strong>“Who is standing <em>after</em> you in line?”</strong></li>
                                </ul>


                                <h2>🔗 Related Topics</h2>
                                <div>
                                    <IonItem routerLink="/lkg/mathematics/pre-math-concepts/long-short"
                                        routerDirection="none"
                                        lines="none"
                                        detail={true}>
                                        <IonLabel>Long - Short</IonLabel>
                                    </IonItem>
                                    <IonItem routerLink="/lkg/mathematics/pre-math-concepts/big-small"
                                        routerDirection="none"
                                        lines="none"
                                        detail={true}>
                                        <IonLabel>Big - Small</IonLabel>
                                    </IonItem>
                                    <IonItem routerLink="/lkg/mathematics/pre-math-concepts/full-empty"
                                        routerDirection="none"
                                        lines="none"
                                        detail={true}>
                                        <IonLabel>Full - Empty</IonLabel>
                                    </IonItem>
                                </div>

                                <h2>🧠 Why This Concept Is Important</h2>
                                <p>
                                    By learning about <strong>heavy and light</strong>, children begin to understand <strong>mass, balance, and physical comparison</strong>. It prepares them for real-world decision-making and future science or math learning.
                                </p>
                            </article>
                            <h2>{question}</h2>
                            <div className="optionImageDiv" style={{ margin: "20px 0", display: "flex", "flexWrap": "wrap", "gap": "30px" }}>
                                {currentObjects.map((object, index) => (
                                    <div key={index} style={{ cursor: "pointer" }} onClick={() => checkAnswer(object)}>
                                        {object}
                                    </div>
                                ))}
                            </div>
                            <p>{message}</p>
                        </div>
                    </>
                    :
                    <>
                        <div className="contentPart showMiddle">
                            <img style={{ height: '150px' }} className='img-fluid' src={process.env.REACT_APP_WELDONE_LINK} />
                        </div>
                    </>
            }
        </>
    );
};

export default BeforeAfter;
